import { Switch, styled } from '@mui/material';

export const StyledSwitch = styled(Switch)(({ theme, checked }) => ({
  width: 55,
  height: 21,
  padding: 0,
  borderRadius: 30,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 2,
    color: theme.palette.background.paper,
    '&.Mui-checked': {
      transform: 'translateX(30px)',
      color: theme.palette.background.paper,
      '& + .MuiSwitch-track': {
        opacity: 1,
      },
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 17,
    height: 17,
    margin: '0px 2px',
  },
  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.divider,
    opacity: 1,
    transition: theme.transitions.create(['background-color']),
    position: 'relative',
    '&::before': {
      content: checked ? '"On"' : '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      left: 8,
      fontSize: 12,
      fontWeight: 700,
      color: theme.palette.text.button,
    },
    '&::after': {
      content: checked ? '""' : '"Off"',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      right: 11,
      fontSize: 12,
      fontWeight: 700,
      color: theme.palette.text.inputPlaceholder,
    },
  },
}));
